export default "__VITE_ASSET__DPwE$pi2__"